module.exports = __webpack_public_path__ + "static/divas4-b9729374cb1ef5a347eb1e0eef26cce0.jpg";